export default __webpack_public_path__ + "static/media/maintain_weight.5abaa7f8.png";